"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _initialState = _interopRequireDefault(require("./initialState"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var reducer = function reducer(state, action) {
  switch (action.type) {
    case "RESET":
      if (typeof window !== "undefined") {
        localStorage && localStorage.removeItem("quizz");
      }

      return _initialState["default"];

    case "INVITE_RESET":
      return _objectSpread({}, state, {
        inviteReset: action.value
      });

    case "START_QUIZZ":
      // récup du résultat en cours
      var startResult = state.results.filter(function (r) {
        return r.question_id === action.value.id;
      });
      return _objectSpread({}, state, {
        started: true,
        currentQuestionnaireID: action.value.questionnaireId,
        currentQuestion: action.value.question,
        currentResult: startResult && startResult.length ? startResult[0] : {}
      });

    case "COMPLETE_QUIZZ":
      return _objectSpread({}, state, {
        completed: true
      });

    case "SET_CURRENT_QUESTION":
      // récup du résultat en cours
      var curResults = state.results.filter(function (r) {
        return r.question_id === action.value.id;
      });
      return _objectSpread({}, state, {
        currentQuestion: action.value,
        currentResult: curResults && curResults.length ? curResults[0] : {}
      });

    case "SET_BOOL_RESULT":
      var newres = {
        question_id: state.currentQuestion.id,
        response_id: +action.value
      };
      return _objectSpread({}, state, {
        results: [].concat(_toConsumableArray(state.results), [newres]),
        currentResult: newres
      });

    case "UPDATE_BOOL_RESULT":
      return _objectSpread({}, state, {
        results: state.results.map(function (res) {
          if (res.question_id === state.currentQuestion.id) {
            return _objectSpread({}, res, {
              response_id: +action.value
            });
          } else {
            return res;
          }
        }),
        currentResult: {
          question_id: state.currentQuestion.id,
          response_id: +action.value
        }
      });

    case "ADD_MULTI_RESULT":
      return _objectSpread({}, state, {
        results: state.results && state.results.length && state.results.filter(function (r) {
          return r.question_id === state.currentQuestion.id;
        }).length ? state.results.map(function (res) {
          // console.log("pour", res.question_id)
          if (res.question_id === state.currentQuestion.id) {
            return _objectSpread({}, res, {
              response_id: res.response_id && res.response_id.length ? [+action.value].concat(res.response_id) : [+action.value]
            });
          } else {
            return res;
          }
        }) : [].concat(_toConsumableArray(state.results), [{
          question_id: state.currentQuestion.id,
          response_id: [+action.value]
        }]),
        currentResult: {
          question_id: state.currentQuestion.id,
          response_id: state.currentResult.response_id && state.currentResult.response_id.length ? [+action.value].concat(state.currentResult.response_id) : [+action.value]
        }
      });

    case "REMOVE_MULTI_RESULT":
      return _objectSpread({}, state, {
        results: state.results.map(function (res) {
          if (res.question_id === state.currentQuestion.id) {
            return _objectSpread({}, res, {
              response_id: res.response_id.filter(function (i) {
                return i !== +action.value;
              })
            });
          } else {
            return res;
          }
        }),
        currentResult: _objectSpread({}, state.currentResult, {
          response_id: state.currentResult.response_id.filter(function (i) {
            return i !== +action.value;
          })
        })
      });

    case "REMOVE_RESET_MULTI_RESULT":
      return _objectSpread({}, state, {
        results: state.results.map(function (res) {
          if (res.question_id === state.currentQuestion.id) {
            return _objectSpread({}, res, {
              response_id: res.response_id.filter(function (i) {
                return i !== action.value;
              })
            });
          } else {
            return res;
          }
        }),
        currentResult: _objectSpread({}, state.currentResult, {
          response_id: state.currentResult.response_id.filter(function (i) {
            return i !== action.value;
          })
        })
      });

    case "RESET_MULTI_RESULT":
      return _objectSpread({}, state, {
        results: state.results.map(function (res) {
          if (res.question_id === state.currentQuestion.id) {
            return _objectSpread({}, res, {
              response_id: []
            });
          } else {
            return res;
          }
        }),
        currentResult: _objectSpread({}, state.currentResult, {
          response_id: []
        })
      });

    case "UPDATE_GLOBAL_SCORE":
      return _objectSpread({}, state, {
        globalScore: +action.value
      });

    default:
      return state;
  }
};

var _default = reducer;
exports["default"] = _default;